import type { ReactNode } from "react";
import React from "react";

import {
  errorStyle,
  messageContainer,
  primaryMessageStyle,
  secondaryMessageStyle
} from "./Alert.css";
import { CloseButton } from "./CloseButton";
import { WarningIcon } from "./WarningIcon";
import { timeoutValue } from "./helpers";

export const ErrorAlert: React.FC<{
  primaryMessage: string;
  secondaryMessage?: string | ReactNode;
  close?: () => void;
}> = ({ primaryMessage, secondaryMessage, close }) => {
  setTimeout(() => {
    close?.();
  }, timeoutValue);

  return (
    <div className={`${messageContainer} ${errorStyle}`}>
      <div style={{ alignSelf: "flex-start" }}>
        <WarningIcon />
      </div>
      <div
        style={{
          width: "100%"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <div className={primaryMessageStyle}>{primaryMessage}</div>
          {close && <CloseButton width="28" height="28" onClick={close} />}
        </div>

        {secondaryMessage && (
          <div className={secondaryMessageStyle}>{secondaryMessage}</div>
        )}
      </div>
    </div>
  );
};
